export default __webpack_public_path__ + "static/media/teacher-icon.774ae0ca.svg";